<template>
  <emd-text-section :title="$t('payment-method.pix')">
    <emd-text-content
      v-if="Object.values(data.expiresIn).length"
      :title="$t('expiresIn.title')"
    >
      <div class="eu-inline">
        <span v-if="data.expiresIn.hours">
          {{ $tc('expiresIn.hours', data.expiresIn.hours) }}
        </span>
        <span v-if="data.expiresIn.hours && data.expiresIn.minutes">
          {{ $t('expiresIn.append') }}
        </span>
        <span v-if="data.expiresIn.minutes">
          {{ $tc('expiresIn.minutes', data.expiresIn.minutes) }}
        </span>
      </div>
    </emd-text-content>

    <due-at
      v-else
      :dueAt="data.expiresAt"
    />

    <discount :data="data" />
  </emd-text-section>
</template>

<script>
import { EmdTextSection, EmdTextContent } from 'emerald-vue/src/components'

export default {
  name: 'PixPaymentLinks',

  components: {
    EmdTextSection,
    EmdTextContent,
    DueAt: () => import('./DueAt.vue'),
    Discount: () => import('./Discount.vue')
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "expiresIn": {
        "title": "Tempo até expirar",
        "hours": " - | 1 hora | {count} horas",
        "minutes": " - | 1 minuto | {count} minutos",
        "append": "e"
      }
    },
    "en-US": {
      "expiresIn": {
        "title": "Time until expire",
        "hours": " - | 1 hour | {count} hours",
        "minutes": " - | 1 minute | {count} minutes",
        "append": "and"
      }
    }
  }
</i18n>
